import User from '../../assets/images/male.png'


export default () => {
    return (
        <div className="card p-3 m-2 bg-light border">
            <div className="d-flex align-items-center">
                <div style={{ width: "50px", height: "50px" }}>
                    <img src={User} className="w-100 h-100 rounded-circle" />
                </div>
                <div className="ms-3">
                    <h6 className="mb-0">Kiara Advani</h6>
                    <p className="fs-9 ">5 years on</p>
                </div>
            </div>
            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptatem cumque fugit non. Ullam in sit doloremque accusamus? Consequatur minima quasi, nihil enim perspiciatis soluta doloribus illo? Reprehenderit hic molestiae voluptatem consectetur cumque ex unde deserunt.</p>
        </div>
    )
}
